var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcquisition = function SvgAcquisition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.001c.835.628 1.875 1 3 1a4.978 4.978 0 0 0 3-.998v3.246a.75.75 0 0 1-1.09.669l-.09-.054L18 20.59l-1.82 1.273a.75.75 0 0 1-1.172-.51l-.007-.105L15 18Zm4.25-14.997a2.75 2.75 0 0 1 2.745 2.583l.005.167.001 5.246a5.025 5.025 0 0 0-1.5-1.33L20.5 5.753a1.25 1.25 0 0 0-1.122-1.243l-.128-.007H4.75a1.25 1.25 0 0 0-1.244 1.123l-.006.127v9.5c0 .648.492 1.18 1.122 1.244l.128.006h8.92c.1.173.21.338.33.497v1.003H4.75a2.75 2.75 0 0 1-2.745-2.582L2 15.254v-9.5A2.75 2.75 0 0 1 4.582 3.01l.168-.005h14.5ZM18 10a4 4 0 1 1 0 8.001 4 4 0 0 1 0-8Z",
    fill: "#2F5EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.5a.75.75 0 0 1 .102 1.493L11.25 14h-4.5a.75.75 0 0 1-.102-1.493l.102-.007h4.5Zm6-5.5a.75.75 0 0 1 .102 1.493l-.102.007H6.75a.75.75 0 0 1-.102-1.493L6.75 7h10.5Z",
    fill: "#D1B896"
  })));
};
export default SvgAcquisition;